import React, { FunctionComponent, SVGAttributes } from 'react';

export const SearchIcon: FunctionComponent<SVGAttributes<SVGElement>> = (props) => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.33317 15C4.65127 15 1.6665 12.0153 1.6665 8.33335C1.6665 4.65146 4.65127 1.66669 8.33317 1.66669C12.0151 1.66669 14.9998 4.65146 14.9998 8.33335C14.9998 9.87395 14.4773 11.2925 13.5997 12.4214L18.0891 16.9108L16.9106 18.0893L12.4212 13.5999C11.2923 14.4775 9.87376 15 8.33317 15ZM13.3332 8.33335C13.3332 11.0948 11.0946 13.3334 8.33317 13.3334C5.57175 13.3334 3.33317 11.0948 3.33317 8.33335C3.33317 5.57193 5.57175 3.33335 8.33317 3.33335C11.0946 3.33335 13.3332 5.57193 13.3332 8.33335Z'
      fill='currentColor'
    />
  </svg>
);
